import { computed, Directive, input } from '@angular/core';

type ButtonSize = 'XS' | 'S' | 'M' | 'L';

export enum ButtonBasicFlavor {
	DEFAULT = 'DEFAULT',
	SUCCESS = 'SUCCESS',
}

const BUTTON_CLASS_BY_SIZE: Record<ButtonSize, string> = {
	XS: 'p-1-rl p-0h-tb br-0t fl-gap-0h',
	S: 'p-1h-rl p-0h-tb br-1 fl-gap-0t',
	M: 'p-2-rl p-1-tb br-1 fl-gap-1',
	L: 'p-3-rl p-1h-tb br-1 fl-gap-1',
};

@Directive({
	selector: '[buttonBasic],[buttonSimple]',
	standalone: true,
	host: {
		class: 'fl fl-ai-c fl-jc-fs fc-400 fs-m',
		'[class.fc-800]': '$active()',
		'[class.bg-primary-20]': '$active() && $flavor() !== "SUCCESS"',
		'[class.bg-standard-hover-on-hover]':
			'!$disabled() && !$active() && $flavor() !== "SUCCESS"',
		'[class.fc-500-on-hover]': '!$disabled() && $flavor() !== "SUCCESS"',
		'[class.fc-node-type]': '$flavor() === "SUCCESS"',
		'[class.website-color]': '$flavor() === "SUCCESS"',
		'[class.bg-success-node-hover]': '$flavor() === "SUCCESS"',
		'[class]': '$sizeClasses()',
		'[attr.disabled]': '$disabled() ? "true" : null',
		style: '--spacing: 8px; transition: background-color 300ms, color 300ms;',
	},
})
export class ButtonBasicDirective {
	public readonly $size = input<ButtonSize>('M', { alias: 'size' });

	public readonly $active = input(false, { alias: 'active' });

	// flavor acepta valores del enum ButtonBasicFlavor; de momento solo SUCCESS
	public readonly $flavor = input(ButtonBasicFlavor.DEFAULT, {
		alias: 'flavor',
	});

	public readonly $disabled = input<boolean, boolean | 'true' | 'false'>(false, {
		alias: 'disabled',
		transform: (value) => {
			return `${value}` === `true`;
		},
	});

	protected readonly $sizeClasses = computed(() => {
		const size = this.$size();
		return BUTTON_CLASS_BY_SIZE[size] ?? '';
	});
}
